
<template>

<ClientOnly>

  <Teleport to="#teleport">
    <Transition name="fade">
      <UiModal
        :width="'350px'"
        title=""
        :is-auto-height="true"
        :is-rounded="true"
        :is-mobile-margin="true"
        @close="close(false)"
        >

        <div class="imb">

          <div class="message">{{props.message}}</div>


          <UiButton
            :name="'Confirm'"
            :type="'primary wide'"
            @click="close(true)"
            />      

          <UiButton
            :name="'Cancel'"
            :tag="'NuxtLink'"
            :type="'link wide'"
            @click="close(false)"
            />   

        </div>

      </UiModal>

    </Transition>    
  </Teleport>    
</ClientOnly>

</template>

<script setup lang="ts">
import { useVModel } from '@vueuse/core'

 // Props
const props = defineProps<{
  modelValue: boolean
  message: string
  okText?: string
  cancelText?: string
}>()

// Emits
const emit = defineEmits<{
  (e: 'update:modelValue', value: boolean): void
  (e: 'close', result: boolean): void
}>()

// Local reactive state
const show = useVModel(props, 'modelValue', emit)

// Close helper
function close(result: boolean) {
  emit('close', result)          // resolve promise in composable
  emit('update:modelValue', false)
}

</script>

<style scoped>
.message{
  font-size: 1.2rem;
  text-align: center;
  max-width: calc(100% - 2rem);
  margin: auto;
  margin-bottom: 1rem;
}
</style>
